import { render } from "./component-sign-date.vue?vue&type=template&id=1a87b63e"
import script from "./component-sign-date.vue?vue&type=script&setup=true&lang=js"
export * from "./component-sign-date.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-sign-date.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a87b63e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a87b63e', __exports__)) {
    api.reload('1a87b63e', __exports__)
  }
  
  module.hot.accept("./component-sign-date.vue?vue&type=template&id=1a87b63e", () => {
    api.rerender('1a87b63e', render)
  })

}


export default __exports__